import React from "react";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";

import TextInput from "../TextInput";
import arrowImage from "./images/arrow";

const getWidth = (props: any) => {
  if (props.width) {
    return props.width - 2;
  }

  if (props.large) {
    return Style.inputSizes.large.width - 2;
  }

  return Style.inputSizes.regular.width - 2;
};
type WrapperProps = {
  disabled?: boolean;
  focus?: boolean;
  highlight?: boolean;
  large?: boolean;
  width?: number;
};
const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  position: relative;
  width: ${props => getWidth(props)}px;
  height: ${props =>
    props.large
      ? Style.inputSizes.large.height - 2
      : Style.inputSizes.regular.height - 2}px;
  border: 1px solid
    ${props =>
      props.highlight
        ? Style.palette.alert
        : props.disabled
          ? Style.palette.grayscale[0]
          : Style.palette.grayscale[3]};
  border-radius: ${Style.borderRadius};
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  transition: all ${Style.animations.swift};
  background: ${props =>
    props.disabled ? Style.palette.grayscale[0] : "white"};

  #dropdown-arrow-image {
    stroke: ${props =>
      props.disabled ? Style.palette.grayscale[0] : Style.palette.black};
  }
  ${props =>
    props.focus
      ? css`
          border-color: ${Style.palette.primaryHighlight};
        `
      : ""}
  &:hover {
    border: 1px solid ${Style.palette.primaryHighlight};
  }
`;
const Arrow = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
type Props = {
  value: string | null;
  customRef?: (ref: HTMLElement | null) => void;
  innerRef?: (ref: HTMLElement | null) => void;
  onChange: (value: string) => void;
  onClick?: () => void;
  disabled?: boolean;
  width?: number;
  large?: boolean;
  onFocus?: () => void;
  highlight?: boolean;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
};
type State = {
  textInputFocus: boolean;
};
class DropdownInput extends React.Component<Props, State> {
  input: HTMLElement | null = null;

  state: State = {
    textInputFocus: false,
  };

  componentDidMount() {
    if (this.input) {
      this.input.focus();
    }
  }

  render() {
    return (
      <Wrapper
        large={this.props.large}
        width={this.props.width}
        focus={this.state.textInputFocus}
        highlight={this.props.highlight}
        disabled={this.props.disabled}
        onMouseDown={this.props.onMouseDown}
        onMouseUp={this.props.onMouseUp}
        ref={e => {
          if (this.props.customRef) {
            this.props.customRef(e);
          } else if (this.props.innerRef) {
            this.props.innerRef(e);
          }
        }}
      >
        <TextInput
          disabled={this.props.disabled}
          value={this.props.value || ""}
          onChange={val => {
            this.props.onChange(val);
          }}
          embedded
          width={this.props.width ? `${this.props.width - 40}px` : "180px"}
          style={{ marginLeft: "16px" }}
          height="29px"
          lineHeight="30px"
          placeholder="Type to search ..."
          onFocus={() => {
            if (this.props.onFocus) {
              this.props.onFocus();
            }
            this.setState({ textInputFocus: true });
          }}
          onBlur={() => {
            this.setState({ textInputFocus: false });
          }}
          _ref={e => {
            this.input = e;
          }}
        />
        <Arrow
          dangerouslySetInnerHTML={{ __html: arrowImage }}
          onClick={this.props.onClick}
        />
      </Wrapper>
    );
  }
}

export default DropdownInput;
